import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';

import { salesVenuesSearchParamsSchema } from './schemas';

export const salesVenuesRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: '/sales-venues',
  component: lazyRouteComponent(() => import('./SalesVenuesView')),
  validateSearch: salesVenuesSearchParamsSchema,
});
